const mapParent = (data, id, parentID, sort = false) => {
  // Sort follow level
  let sortedData,
      remainData = JSON.parse(JSON.stringify(data));

  if (sort) {
    let temp = [];
    sortedData = remainData.filter(item => {
      if (!item[parentID] || item[parentID] === item[id]) {
        return true;
      }

      temp.push(item);
      return false;
    });
    let remainLength = 0;

    while (temp.length && temp.length !== remainLength) {
      remainLength = temp.length;
      remainData = [...temp];
      const inserted = [];
      temp = [];
      remainData.forEach(item => {
        if (sortedData.some(remainData => remainData[id] === item[parentID])) {
          inserted.push(item);
        } else {
          temp.push(item);
        }
      });
      sortedData.push(...inserted);
    }
  } else {
    sortedData = remainData;
  } // Mapping follow parent


  for (let i = sortedData.length - 1; i > -1; i--) {
    const index = sortedData.findIndex(item => item[id] === sortedData[i][parentID]);

    if (index !== -1 && i !== index) {
      if (!sortedData[index].childItems) {
        sortedData[index].childItems = [];
      }

      sortedData[index].childItems.unshift(sortedData[i]);
      sortedData.splice(i, 1);
    }
  }

  return sortedData;
};

export default mapParent;